import { styled } from "styled-components";
import CharacterGenerator from "./CharacterGenerator";
import { createGlobalStyle } from "styled-components";
import { Colors } from "../constants";
import { useState } from "react";
import Rules from "./Rules";
import EncounterGenerator from "./EncounterGenerator";

const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
    overflow: hidden;
    background: ${Colors.Red}
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  @media (max-width: 800px) {
    overflow-y: scroll;
  }
`;

function App() {
  const [currentPage, setCurrentPage] = useState("rules");
  const [roll, setRoll] = useState(null);
  const [rollTimerId, setRollTimerId] = useState(null);

  const getRollMessage = (roll, character) => {
    let newRollMessage = "";
    if (roll.name === "defense" && character) {
      if (roll.withBonus > character.bonuses.defense + 10) {
        newRollMessage = "You died.";
      } else {
        newRollMessage = "You survived.";
      }
    } else if (roll.name === "") {
      newRollMessage = "You rolled ";
    } else {
      newRollMessage = roll.name + " for ";
    }
    return newRollMessage;
  };

  const rollDie = (name, bonus, character) => {
    if (roll === null) {
      const naturalRoll = Math.floor(Math.random() * 20) + 1;
      const rollWithBonus = naturalRoll + bonus;
      const newRoll = {
        name: name,
        natural: naturalRoll,
        withBonus: rollWithBonus,
        character: character ? character : null,
      };
      newRoll.message = getRollMessage(newRoll);
      if (rollTimerId) {
        clearTimeout(rollTimerId);
        setRoll(newRoll);
        const rollTimer = setTimeout(() => {
          setRoll(null);
        }, 3000);
        setRollTimerId(rollTimer);
      } else {
        setRoll(newRoll);
        const rollTimer = setTimeout(() => {
          setRoll(null);
        }, 3000);
        setRollTimerId(rollTimer);
      }
    }
  };
  return (
    <>
      <GlobalStyle />
      <Wrapper>
        {currentPage === "character" && (
          <CharacterGenerator roll={roll} rollDie={rollDie} />
        )}
        {currentPage === "rules" && <Rules setCurrentPage={setCurrentPage} />}
        {currentPage === "encounter" && (
          <EncounterGenerator roll={roll} rollDie={rollDie} b />
        )}
      </Wrapper>
    </>
  );
}

export default App;
